// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { CommentFeedFragmentDoc } from '../../../components/comments/CommentFeed.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateCommitmentDataDevelopmentFragment = { __typename?: 'Development', id: string, name: string };

export type DevelopmentCommitmentOverviewTabQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DevelopmentCommitmentOverviewTabQuery = { __typename?: 'Query', developmentCommitment: { __typename?: 'DevelopmentCommitment', id: string, canBeEdited: boolean, committedInCents: number, internalNote?: string | null | undefined, name: string, stage: Types.Stage, status: Types.CommitmentStatus, supportedVisibilities: Array<Types.CommentStreamVisibility>, costCodeSummary: Array<{ __typename?: 'DevelopmentCommitmentCostCodeSummary', numberOfProjects: number, quantity: number, costCode: { __typename?: 'CostCode', id: string, name: string, number: string } }>, costTypes?: Array<{ __typename?: 'CostTypeDetail', code: Types.CostType, name: string }> | null | undefined, market: { __typename?: 'Market', id: string, name: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, availableFollowers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, development: { __typename?: 'Development', id: string, name: string }, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> }, tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string }>, developments: Array<{ __typename?: 'Development', id: string, name: string }> };

export type DevelopmentCommitmentOverviewTabFragment = { __typename?: 'DevelopmentCommitment', id: string, canBeEdited: boolean, committedInCents: number, internalNote?: string | null | undefined, name: string, stage: Types.Stage, status: Types.CommitmentStatus, supportedVisibilities: Array<Types.CommentStreamVisibility>, costCodeSummary: Array<{ __typename?: 'DevelopmentCommitmentCostCodeSummary', numberOfProjects: number, quantity: number, costCode: { __typename?: 'CostCode', id: string, name: string, number: string } }>, costTypes?: Array<{ __typename?: 'CostTypeDetail', code: Types.CostType, name: string }> | null | undefined, market: { __typename?: 'Market', id: string, name: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, availableFollowers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, development: { __typename?: 'Development', id: string, name: string }, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> };

export type DevelopmentCommitmentDetailsFragment = { __typename?: 'DevelopmentCommitment', id: string, committedInCents: number, name: string, stage: Types.Stage, status: Types.CommitmentStatus, supportedVisibilities: Array<Types.CommentStreamVisibility>, market: { __typename?: 'Market', id: string, name: string }, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, availableFollowers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus } | null | undefined, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, costTypes?: Array<{ __typename?: 'CostTypeDetail', code: Types.CostType, name: string }> | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> };

export type DevelopmentCommitmentMarketDetailsFragment = { __typename?: 'Market', id: string, name: string };

export type DevelopmentCommitmentTradeCategoryDetailsFragment = { __typename?: 'TradeCategory', id: string, name: string };

export type DevelopmentCommitmentTradePartnerDetailsFragment = { __typename?: 'TradePartner', id: string, name: string };

export type DevelopmentCommitmentProjectDetails_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string };

export type DevelopmentCommitmentProjectDetails_Region_Fragment = { __typename?: 'Region', id: string, name: string };

export type DevelopmentCommitmentProjectDetails_Market_Fragment = { __typename?: 'Market', id: string, name: string };

export type DevelopmentCommitmentProjectDetails_Community_Fragment = { __typename?: 'Community', id: string, name: string };

export type DevelopmentCommitmentProjectDetails_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string };

export type DevelopmentCommitmentProjectDetails_Lot_Fragment = { __typename?: 'Lot', id: string, name: string };

export type DevelopmentCommitmentProjectDetails_Structure_Fragment = { __typename?: 'Structure', id: string, name: string };

export type DevelopmentCommitmentProjectDetails_Unit_Fragment = { __typename?: 'Unit', id: string, name: string };

export type DevelopmentCommitmentProjectDetailsFragment =
  | DevelopmentCommitmentProjectDetails_StandaloneProject_Fragment
  | DevelopmentCommitmentProjectDetails_Region_Fragment
  | DevelopmentCommitmentProjectDetails_Market_Fragment
  | DevelopmentCommitmentProjectDetails_Community_Fragment
  | DevelopmentCommitmentProjectDetails_Subdivision_Fragment
  | DevelopmentCommitmentProjectDetails_Lot_Fragment
  | DevelopmentCommitmentProjectDetails_Structure_Fragment
  | DevelopmentCommitmentProjectDetails_Unit_Fragment
;

export type SaveDevelopmentCommitmentMutationVariables = Types.Exact<{
  input: Types.SaveDevelopmentCommitmentInput;
}>;


export type SaveDevelopmentCommitmentMutation = { __typename?: 'Mutation', saveDevelopmentCommitment: { __typename?: 'SaveDevelopmentCommitmentResult', developmentCommitment: { __typename?: 'DevelopmentCommitment', id: string, committedInCents: number, name: string, stage: Types.Stage, status: Types.CommitmentStatus, supportedVisibilities: Array<Types.CommentStreamVisibility>, market: { __typename?: 'Market', id: string, name: string }, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, availableFollowers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus } | null | undefined, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, costTypes?: Array<{ __typename?: 'CostTypeDetail', code: Types.CostType, name: string }> | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> } } };

export const CreateCommitmentDataDevelopmentFragmentDoc = gql`
    fragment CreateCommitmentDataDevelopment on Development {
  id
  name
}
    `;
export const DevelopmentCommitmentOverviewTabFragmentDoc = gql`
    fragment DevelopmentCommitmentOverviewTab on DevelopmentCommitment {
  id
  canBeEdited
  committedInCents
  costCodeSummary {
    costCode {
      id
      name
      number
    }
    numberOfProjects
    quantity
  }
  costTypes {
    code
    name
  }
  internalNote
  market {
    id
    name
  }
  name
  stage
  status
  tradePartner {
    id
    name
  }
  availableFollowers {
    id
    name
    avatar
    email
  }
  development {
    id
    name
  }
  ...CommentFeed
}
    ${CommentFeedFragmentDoc}`;
export const DevelopmentCommitmentMarketDetailsFragmentDoc = gql`
    fragment DevelopmentCommitmentMarketDetails on Market {
  id
  name
}
    `;
export const DevelopmentCommitmentTradeCategoryDetailsFragmentDoc = gql`
    fragment DevelopmentCommitmentTradeCategoryDetails on TradeCategory {
  id
  name
}
    `;
export const DevelopmentCommitmentTradePartnerDetailsFragmentDoc = gql`
    fragment DevelopmentCommitmentTradePartnerDetails on TradePartner {
  id
  name
}
    `;
export const DevelopmentCommitmentProjectDetailsFragmentDoc = gql`
    fragment DevelopmentCommitmentProjectDetails on Project {
  id
  name
}
    `;
export const DevelopmentCommitmentDetailsFragmentDoc = gql`
    fragment DevelopmentCommitmentDetails on DevelopmentCommitment {
  id
  committedInCents
  name
  stage
  market {
    ...DevelopmentCommitmentMarketDetails
  }
  status
  tradeCategories {
    ...DevelopmentCommitmentTradeCategoryDetails
  }
  tradePartner {
    ...DevelopmentCommitmentTradePartnerDetails
  }
  projects {
    ...DevelopmentCommitmentProjectDetails
  }
  availableFollowers {
    id
    name
    avatar
    email
  }
  ...CommentFeed
  pandaDoc {
    id
    externalPandaDocUrl
    status
  }
  canCreatePandaDoc {
    allowed
    disabledReasons {
      message
    }
  }
  costTypes {
    code
    name
  }
}
    ${DevelopmentCommitmentMarketDetailsFragmentDoc}
${DevelopmentCommitmentTradeCategoryDetailsFragmentDoc}
${DevelopmentCommitmentTradePartnerDetailsFragmentDoc}
${DevelopmentCommitmentProjectDetailsFragmentDoc}
${CommentFeedFragmentDoc}`;
export const DevelopmentCommitmentOverviewTabDocument = gql`
    query DevelopmentCommitmentOverviewTab($id: ID!) {
  developmentCommitment(id: $id) {
    ...DevelopmentCommitmentOverviewTab
  }
  tradePartners {
    id
    name
  }
  developments(filter: {}) {
    ...CreateCommitmentDataDevelopment
  }
}
    ${DevelopmentCommitmentOverviewTabFragmentDoc}
${CreateCommitmentDataDevelopmentFragmentDoc}`;

/**
 * __useDevelopmentCommitmentOverviewTabQuery__
 *
 * To run a query within a React component, call `useDevelopmentCommitmentOverviewTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentCommitmentOverviewTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentCommitmentOverviewTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDevelopmentCommitmentOverviewTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables> & ({ variables: DevelopmentCommitmentOverviewTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables>(DevelopmentCommitmentOverviewTabDocument, options);
      }
export function useDevelopmentCommitmentOverviewTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables>(DevelopmentCommitmentOverviewTabDocument, options);
        }
// @ts-ignore
export function useDevelopmentCommitmentOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables>;
export function useDevelopmentCommitmentOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentCommitmentOverviewTabQuery | undefined, DevelopmentCommitmentOverviewTabQueryVariables>;
export function useDevelopmentCommitmentOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables>(DevelopmentCommitmentOverviewTabDocument, options);
        }
export type DevelopmentCommitmentOverviewTabQueryHookResult = ReturnType<typeof useDevelopmentCommitmentOverviewTabQuery>;
export type DevelopmentCommitmentOverviewTabLazyQueryHookResult = ReturnType<typeof useDevelopmentCommitmentOverviewTabLazyQuery>;
export type DevelopmentCommitmentOverviewTabSuspenseQueryHookResult = ReturnType<typeof useDevelopmentCommitmentOverviewTabSuspenseQuery>;
export type DevelopmentCommitmentOverviewTabQueryResult = Apollo.QueryResult<DevelopmentCommitmentOverviewTabQuery, DevelopmentCommitmentOverviewTabQueryVariables>;
export const SaveDevelopmentCommitmentDocument = gql`
    mutation SaveDevelopmentCommitment($input: SaveDevelopmentCommitmentInput!) {
  saveDevelopmentCommitment(input: $input) {
    developmentCommitment {
      ...DevelopmentCommitmentDetails
    }
  }
}
    ${DevelopmentCommitmentDetailsFragmentDoc}`;
export type SaveDevelopmentCommitmentMutationFn = Apollo.MutationFunction<SaveDevelopmentCommitmentMutation, SaveDevelopmentCommitmentMutationVariables>;

/**
 * __useSaveDevelopmentCommitmentMutation__
 *
 * To run a mutation, you first call `useSaveDevelopmentCommitmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDevelopmentCommitmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDevelopmentCommitmentMutation, { data, loading, error }] = useSaveDevelopmentCommitmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDevelopmentCommitmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDevelopmentCommitmentMutation, SaveDevelopmentCommitmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDevelopmentCommitmentMutation, SaveDevelopmentCommitmentMutationVariables>(SaveDevelopmentCommitmentDocument, options);
      }
export type SaveDevelopmentCommitmentMutationHookResult = ReturnType<typeof useSaveDevelopmentCommitmentMutation>;
export type SaveDevelopmentCommitmentMutationResult = Apollo.MutationResult<SaveDevelopmentCommitmentMutation>;
export type SaveDevelopmentCommitmentMutationOptions = Apollo.BaseMutationOptions<SaveDevelopmentCommitmentMutation, SaveDevelopmentCommitmentMutationVariables>;